<template>
    <NuxtLink :to="props.to" class="navigation-tab" :title="label" :data-testid="`navigation-tab-${dataId}`">
        <div class="navigation-tab_wrapper">
            <span>{{ label }}</span>
            <!-- Display if notificationsCount != null and > 0 -->
            <VJoyDot v-if="notificationsCount" :number="notificationsCount" class="navigation-tab_wrapper_badge" variant="pink"></VJoyDot>
        </div>
    </NuxtLink>
</template>

<script setup lang="ts" generic="T extends RoutesNamesList, P extends string">
    import type {NuxtRoute, RoutesNamesList} from '@typed-router';
    import {VJoyDot} from '@maltjoy/core-vue';

    const props = defineProps<{
        to: NuxtRoute<T, P, false>;
        label: string;
        notificationsCount?: number;
        dataId: string;
    }>();
</script>

<style lang="scss" scoped>
    .navigation-tab {
        padding: var(--joy-core-spacing-2) var(--joy-core-spacing-10);
        position: relative;
        border-radius: var(--joy-core-radius-3) var(--joy-core-radius-3) 0 0;
        transition:
            background-color 0.2s ease,
            color 0.2s ease;
        height: 40px;
        width: 164px;
        font-size: var(--joy-font-size-primary-300);

        &_wrapper {
            // add fixed height to align all items, no matter if they have notification count or not
            height: 24px;
            display: flex;
            flex-flow: row nowrap;
            align-items: center;
            justify-content: center;
            white-space: nowrap;

            .joy-dot {
                margin-left: var(--joy-core-spacing-2);
                line-height: 1.1;
                padding: 0 6px;
            }
        }

        &.router-link-active {
            color: var(--joy-color-primary-50);
            font-weight: var(--joy-font-weight-bold);

            &::after {
                background-color: var(--joy-color-primary-50);
            }
        }

        &:hover {
            background-color: var(--joy-color-neutral-20);
        }

        &::after {
            position: absolute;
            content: '';
            top: calc(100% - 2px);
            height: 2px;
            width: 100%;
            left: 0;
            background-color: transparent;
            z-index: 1;
            transition: background-color 0.2s ease;
        }

        // Prevent layout shift when font become bold
        &::before {
            display: block;
            content: attr(title);
            font-weight: var(--joy-font-weight-bold);
            height: 0;
            overflow: hidden;
            visibility: hidden;
        }
    }
</style>
